import React from "react";
import Avatar from '@material-ui/core/Avatar';
import firebase from "firebase";

class UserAvatar extends React.Component {
    state = { photo_url: "" };   

    componentDidMount() {
        this.getUrl().then(url => this.setState({ photo_url: url }));
    }

    async getUrl(){
        if (this.props.attributes["stud_picture"] != "") {
            var file_path = "images/" + this.props.attributes["stud_picture"];
            return await firebase.storage().ref().child(file_path).getDownloadURL();    
        }
    }

    render() {
        return(
            <div>
                <Avatar src={this.state.photo_url}/>
            </div>
        );
    }
}


export default UserAvatar